var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVerticalDots = function SvgVerticalDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 18,
    viewBox: "0 0 4 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.925 11A2 2 0 1 1 4 9a2.038 2.038 0 0 1-2.075 2Zm0-7A2 2 0 1 1 4 2a2.038 2.038 0 0 1-2.075 2Zm.15 10A2 2 0 1 1 0 16a2.042 2.042 0 0 1 2.075-2Z",
    fill: "param(fill)",
    fillRule: "evenodd"
  })));
};
export default SvgVerticalDots;